import { Observable, Subject, takeUntil, timer } from 'rxjs';

import { LoadingIndicatorOptions } from './loading-indicator.models';

/**
 * Handler for closing loading indicator returned by {@link LoadingIndicatorService}.
 *
 * @stable
 */
export class LoadingIndicatorHandler {
    get show(): Observable<boolean> {
        return this.showEvents;
    }

    private readonly showEvents = new Subject<boolean>();
    private readonly unsubscribe = new Subject();

    /**
     * @internal
     */
    constructor(readonly options: LoadingIndicatorOptions) {
        if (!options.disabled) {
            timer(options.delay ?? 0)
                .pipe(takeUntil(this.unsubscribe))
                .subscribe(() => this.showEvents.next(true));
        }
    }

    done() {
        this.unsubscribe.next(null);
        this.unsubscribe.complete();
        this.showEvents.next(false);
    }
}
